<template>
	<div>
		<div style="padding: 0 260px 50px;">
			<div class="nodea" v-if="count.length == 0"><img src="../../../../assets/img/nodata.png" /></div>
			<div class="list_box p_b_b small_hand" v-for="(item, index) in count" @click="goDeatil(item.id, item.job_type)" :key="index" infinite-scroll-disabled="disabled">
				<span class="type_size_22">{{ item.name }}</span>
				<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
					<div class="p_flex ">
						<span class="subject_color">{{ item.classLevel.name }}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{ item.subject_def }}</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{ item.question_count }}道题</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{ item.score }}分</span>
					</div>
					<el-button type="warning" size="mini" @click.stop="withdraw(item.id)">撤回</el-button>
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
					<div class="p_flex ">参与人数</div>
					<div class="p_f_1 p_m_l_20  p_m_r_20">
						<el-progress
							:text-inside="true"
							:show-text="false"
							color="#00AF63"
							:stroke-width="20"
							:percentage="item.already_submit == item.should_submit ? 100 : (item.already_submit / item.should_submit) * 100"
							status="success"
						></el-progress>
					</div>
					<span>{{ item.already_submit }}/{{ item.should_submit }}</span>
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
					<div class="p_flex ">提交时间 {{ item.create_date }} 至 {{ item.submit_date }}</div>
					<div class="p_flex"><el-button @click.stop="goDeatils(item.id)" type="success" size="mini">查看提交详情</el-button></div>
				</div>
			</div>
		</div>
		<pagination @get="get" :index="num" />
		<!-- <div class="p_flex p_f_c p_m_t_20 p_m_b_20" v-if="loading">加载中...</div>
		<div class="p_m_l_20 p_m_r_20" v-if="noMore"><el-divider>没有更多了</el-divider></div> -->
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';
export default {
	data() {
		return {
			count: [],
			loading: false,
			num: 0
		};
	},
	components: {
		pagination
	},
	created() {
		this.get();
	},
	computed: {
		// noMore() {
		// 	return this.count >= 20;
		// },
		// disabled() {
		// 	return this.loading || this.noMore;
		// }
	},
	mounted() {},
	methods: {
		get(id) {
			// console.log(id)
			this.$request
				.ajax(this)
				.post('/api_teacher/publish_already_list', {
					page: id ? id : 1, //第几页
					limit: 10 //，每页显示
				})
				.then(res => {
					// console.log(res)
					this.num = parseInt(res.data.count);
					this.count = res.data.list;
				});
		},
		// load() {
		// 	this.loading = true;
		// 	setTimeout(() => {
		// 		this.count += 2;
		// 		this.loading = false;
		// 	}, 2000);
		// },
		goDeatils(id) {
			// console.log(id)
			this.$emit('submit', true, id);
		},
		withdraw(id) {
			var that = this;
			that.$confirm('确定撤回吗?', '提示', {
				confirmButtonText: '确定',
				type: 'warning'
			})
				.then(() => {
					that.withdrawInfo(id);
				})
				.catch(() => {});
		},
		withdrawInfo(id) {
			this.$request
				.ajax(this)
				.post('/api_teacher/publish_delete', {
					job_publish_id: id
				})
				.then(res => {
					// console.log(res)
					this.$message({
						message: '撤回成功',
						type: 'success'
					});
					this.get();
				});
		},

		goDeatil(id, type) {
			if (type == 2) {
				this.$router.push({
					path: '/SentSheet',
					query: {
						id: id,
						type: type,
						i: 0
					}
				});
			} else {
				this.$router.push({
					path: '/SentDeatil',
					query: {
						id: id,
						type: type
					}
				});
			}
			//查看详情
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/list.css';
.btn {
	background-color: #00af63 !important;
	border-color: #00af63 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/sent/commponents/performList.vue